import { useSEMRushWebsiteTrafficCRUDActions } from '@mm/state/actions/SEMRushWebsiteTrafficActions';
import {
  SEMRushWebsiteTrafficByMonthModel,
  SEMRushWebsiteTrafficModel,
} from '@mm/state/model/SEMRushWebsiteTrafficModel';
import { useRef, useState } from 'react';

export const useGetWebsiteTraffic = ({
  onTrafficAbsent,
  onNonUSTraffic,
  setShowPaidTrafficROI,
}: {
  onTrafficAbsent?: () => void;
  onNonUSTraffic?: () => void;
  setShowPaidTrafficROI?: (yes: boolean) => void;
}) => {
  const { retriveTotalsByDomain, retriveMonthlyByDomain } =
    useSEMRushWebsiteTrafficCRUDActions();
  const [busy, setBusy] = useState(false);
  const totalTrafficRef = useRef<SEMRushWebsiteTrafficModel>({});
  const monthlyTrafficRef = useRef<SEMRushWebsiteTrafficByMonthModel>({});
  const [totalTraffic, setTotalTraffic] = useState<SEMRushWebsiteTrafficModel>(
    {},
  );

  const retrieveStats = async (domain: string) => {
    let data;
    try {
      setBusy(true);

      const response = await fetch('https://geolocation-db.com/json/');
      data = await response.json();
    } catch (e) {
    } finally {
      setBusy(false);
    }

    try {
      setBusy(true);
      const totals = await retriveTotalsByDomain(domain, data?.IPv4);
      if (totals) {
        totalTrafficRef.current = totals;
        setTotalTraffic(totals);
        const trafficSum =
          (totals?.trafficTypes?.paid || 0) +
          (totals?.trafficTypes?.organic || 0);

        if (!totals?.trafficTypes || trafficSum < 1000) {
          onTrafficAbsent?.();
          setShowPaidTrafficROI?.(true);
        }
        if (
          totals?.trafficTypes &&
          !totals?.trafficTypes?.usBasedTraffic &&
          trafficSum !== 0
        ) {
          onNonUSTraffic?.();
        }

        if (totals?.trafficTypes?.paid > 0) {
          setShowPaidTrafficROI?.(true);
        }

        if (trafficSum > 1000) {
          const monthly = await retriveMonthlyByDomain(domain, data?.IPv4);
          if (monthly) {
            monthlyTrafficRef.current = monthly;
          }
        }
      }
    } catch (e) {
    } finally {
      setBusy(false);
    }
  };

  return {
    retrieveStats,
    totalTrafficRef,
    monthlyTrafficRef,
    busy,
    totalTraffic,
    setTotalTraffic,
  };
};
